import { PRODUCTION_REQUEST, CREATE_PRODUCTION, GET_PRODUCTIONS, UPDATE_PRODUCTION, DELETE_PRODUCTION, PRODUCTION_REQUEST_FAILURE, GET_PRODUCTION_PAGE, PRODUCTION_REQUEST_SUCCESS } from '../types';

const initialState = {
  productions: [],
  productionsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const productionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PRODUCTIONS: {
      return {
        ...state,
        productions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        productionsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case PRODUCTION_REQUEST_SUCCESS: {
      return {
          ...state,
          loading: false,
          error: null
        }
    }
    case CREATE_PRODUCTION:
      return {
        ...state,
        productions: [action.payload, ...state.productions],
        loading: false,
        error: null
      };
    case UPDATE_PRODUCTION:
      const productionsData = state.productions.slice(0);
      const uIndex = productionsData.findIndex((data) => data.id === action.payload.id);
      productionsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        productions: [ ...productionsData ],
        loading: false,
        error: null
      };
    case DELETE_PRODUCTION:
      const productions = state.productions?.slice(0);
      const index = productions.findIndex((data) => data.id === action.id);
      if (index > -1) {
        productions.splice(index, 1);
      }
      return {
        ...state,
        productions: [...productions],
        loading: false,
        error: null
      }
    case PRODUCTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default productionReducer;
